import { SsAuthService } from '../SS-Auth/ss-auth.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { AppUser } from 'app/models/app-user';
import { FacebookService, LoginResponse, LoginOptions, InitParams } from 'ngx-facebook';
import { error } from 'util';
import { MatDialog } from '@angular/material';
import { Injector } from '@angular/core';
import { AlertPopupService } from './../SS-Alert/alert-popup.service';
import { environment } from 'environments/environment';
import { UIService } from '../UI/ui.service';
import { EmailVerificationDialogComponent } from './AuthDialog/email-verification/email-verification.component';
import { DataSharingService } from '../data-sharing/data-sharing.service';
import { Subject } from 'rxjs/Subject';

declare var mixpanel;

@Injectable()
export class UserService {
  user: AppUser = {
    email: '',
    password: '',
    firstName: '',
    lastName: '',
    token: '',
    isLoggedIn: false,
    uid: '',
    team_auths: '',
    thumb_img: '',
    req_onboarding: [],
    payout_methods: []
  };
  router;
  fb;
  dialog;
  ui;

  authStateChange = new Subject<any>();

  // FB OPTIONS
  loginOptions: LoginOptions = {
    enable_profile_selector: true,
    return_scopes: true,
    scope: 'public_profile,email,pages_show_list'
  };
  authState: boolean;
  constructor(
    private injector: Injector,
    private apiService: SsAuthService,
    private alertService: AlertPopupService,
    private data: DataSharingService) {
    setTimeout(() => {
      this.router = injector.get(Router);
      this.fb = injector.get(FacebookService);
      this.dialog = injector.get(MatDialog);
      this.ui = injector.get(UIService);
      const initParams: InitParams = {
        appId: environment.FACEBOOK_ID,
        xfbml: true,
        version: 'v2.8'
      };
      this.fb.init(initParams);
    });
    console.log(this.user)
  }

  loginUser(userData, groupId?) {
    localStorage.removeItem('SSUserCookie');
    const result = new Promise((resolve, reject) => {
      this.apiService.login(userData).subscribe(res => {
        if (res.response_info.code === '200') {
          this.user = res.user;
          this.user.req_onboarding = res.req_onboarding;
          this.user.payout_methods = res.payout_methods;
          this.user.team_auths = res.team_auths;
          // set cookie
          this.user.profImage = res.user.thumb_img;
          this.user.firstName = res.user.first_name;
          this.user.lastName = res.user.last_name;
          this.user.token = res.user.token;
          localStorage.setItem('SSUserCookie', JSON.stringify(this.user));
          this.authStateChange.next({ isLoggedIn: this.isLoggedIn() });
          this.authState = true;
          mixpanel.identify(res.user.uid);
          mixpanel.track("Logged in", {})
          mixpanel.people.set({
            "$email": res.user.email,    // only reserved properties need the $
            "Sign up date": new Date(),    // Send dates in ISO timestamp format (e.g. "2020-01-02T21:07:03Z")
            "USER_ID": res.user.uid,    // use human-readable names
          });
          resolve(true);
        } else {
          reject(false);
        }
      }, err => {
        const errBody = JSON.parse(err._body);
        this.alertService.errorAlert(errBody.error.message);
        reject(false);
      });
    });
    return result;
  }

  signUpUserByEmail(user) {
    const result = new Promise((resolve, reject) => {
      this.apiService.register(user).subscribe(res => {
        if (res.response_info.code === '200') {
          this.user.email = res.user.email;
          this.user.firstName = res.user.first_name;
          this.user.lastName = res.user.last_name;
          this.user.token = res.user.token;
          this.user.profImage = res.user.thumb_img;
          this.user.uid = res.user.uid;
          this.user.req_onboarding = res.req_onboarding;
          this.user.payout_methods = res.payout_methods;
          this.user.team_auths = res.team_auths;
          this.user.isLoggedIn = true;
          localStorage.setItem('SSUserCookie', JSON.stringify(this.user));
          this.authStateChange.next({ isLoggedIn: this.isLoggedIn() });
          mixpanel.identify(res.user.uid);
          mixpanel.track("New user registered", {})
          // init the user's visit
          resolve(true);
        }
      }, err => {
        resolve(false);
        const errBody = JSON.parse(err._body);
        const errCode = errBody.error.code;
        if (errCode === '400') {
          this.alertService.errorAlert(errBody.error.message);
        }
      });
    });
    return result;
  }

  register(user) {
    const result = new Promise((resolve, reject) => {
      this.apiService.register(user).subscribe(res => {
        if (res.response_info.code === '200') {
          this.user.email = res.user.email;
          this.user.firstName = res.user.first_name;
          this.user.lastName = res.user.last_name;
          this.user.token = res.user.token;
          this.user.profImage = res.user.thumb_img;
          this.user.uid = res.user.uid;
          this.user.req_onboarding = res.req_onboarding;
          this.user.payout_methods = res.payout_methods;
          this.user.team_auths = res.team_auths;
          this.user.isLoggedIn = true;
          localStorage.setItem('SSUserCookie', JSON.stringify(this.user));
          this.authStateChange.next({ isLoggedIn: this.isLoggedIn() });
          // init the user's visit
          resolve(true);
        }
      }, err => {
        resolve(false);
        const errBody = JSON.parse(err._body);
        const errCode = errBody.error.code;
        if (errCode === '400') {
          this.alertService.errorAlert(errBody.error.message);
        }
      });
    });
    return result;
  }


  initFbSignInFromAnywhere(viewName): void {
    this.fb.login(this.loginOptions)
      .then((res: LoginResponse) => {
        this.getProfilev2(res.authResponse.accessToken, viewName);
      })
      .catch((err: any) => console.error(err));
  }

  initFbSignIn(): void {
    this.fb.login(this.loginOptions)
      .then((res: LoginResponse) => {
        this.getProfile(res.authResponse.accessToken);
      })
      .catch((err: any) => console.error(err));
  }

  getProfilev2(token, viewName) {
    this.fb.api('/me?fields=link,id,name,first_name,last_name, email')
      .then((user: any) => {
        user.token = token;
        this.apiService.loginFacebook(user).subscribe(res => {
          console.log(res);
          if (res.response_info.code === '200') {
            // set local user data
            this.user.email = res.user.email;
            this.user.firstName = res.user.first_name;
            this.user.lastName = res.user.last_name;
            this.user.token = res.user.token;
            this.user.uid = res.user.uid;
            this.user.req_onboarding = res.req_onboarding;
            this.user.payout_methods = res.payout_methods;
            this.user.team_auths = res.team_auths;
            this.user.isLoggedIn = true;
            this.user.profImage = res.user.thumb_img;
            // set cookie
            localStorage.setItem('SSUserCookie', JSON.stringify(this.user));
            this.authStateChange.next({ isLoggedIn: this.isLoggedIn() });
            // navigate to home page
            this.router.navigate([viewName]).then(() => {
              // dont do anything, async update the state
            });

          } else {
            this.alertService.errorAlert('Bad login attempt');
          }
        });
      })
      .catch(error);
  }

  getProfile(token) {
    this.fb.api('/me?fields=link,id,name,first_name,last_name, email')
      .then((user: any) => {
        user.token = token;
        this.apiService.loginFacebook(user).subscribe(res => {
          console.log(res);
          if (res.response_info.code === '200') {
            // set local user data
            this.user.email = res.user.email;
            this.user.firstName = res.user.first_name;
            this.user.lastName = res.user.last_name;
            this.user.token = res.user.token;
            this.user.uid = res.user.uid;
            this.user.req_onboarding = res.req_onboarding;
            this.user.payout_methods = res.payout_methods;
            this.user.team_auths = res.team_auths;
            this.user.isLoggedIn = true;
            this.user.profImage = res.user.thumb_img;
            // set cookie
            localStorage.setItem('SSUserCookie', JSON.stringify(this.user));
            this.authStateChange.next({ isLoggedIn: this.isLoggedIn() });
            // navigate to home page
            this.router.navigate(['/groups']);
          } else {
            this.alertService.errorAlert('Bad login attempt');
          }
        });
      })
      .catch(error);
  }

  isLoggedIn(): boolean {
    const userAuth = localStorage.getItem('SSUserCookie');
    if (!userAuth) {
      return false;
    } else {
      // this is fine as long as u force reload on views where data should be most up-to-date
      this.user = JSON.parse(userAuth);
      return true;
    }
  }

  // LOGS OUT USER
  logout() {
    localStorage.removeItem('SSUserCookie');
    this.user.token = null;
    if (this.router.url === '/reservations/create') {
      this.router.navigateByUrl('/reservations/create');
    } else if (this.router.url.includes('/new-group/public-groups/view-detail')) {
      window.location.reload();
    }
    else {
      this.router.navigateByUrl('/welcome');
    }
    this.authStateChange.next({ isLoggedIn: this.isLoggedIn() });
  }

  get(): Observable<AppUser> {
    return Observable.of(this.user);
  }

  getTeamAccountID(team_id) {
    const a = this.user.team_auths.filter(auth => (auth.team_id_fk === `${team_id}`));
    if(!a[0]){
      return false; 
    }
    return a[0]['acct_id'];
  }

  // Check if team connected
  isTeamConnected(team_id) {
    try {
      const a = this.user.team_auths.filter(auth => (auth.team_id_fk === team_id));
      if (a.length > 0) {
        return true;
      } else {
        return false;
      }
    } catch (err) {
      return false;
    }
  }

  openEmailVerificationDialog(invalid?) {
    console.log('Opening emai dialog...');
    const data = { profImage: this.user.profImage, firstName: this.user.firstName, lastName: this.user.lastName };
    const dialogRef = this.dialog.open(EmailVerificationDialogComponent, {
      width: '60%',
      height: '65%',
      hasBackdrop: true,
      backdropClass: 'onboarding-dialog-backdrop',
      panelClass: 'verify-email-dialog-container',
      data: { invalid: invalid, email: this.user.email }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      // Resend
      if (result === 'RESEND') {
        this.ui.emitLoaderMessage('Resending email...');
        this.apiService.resendVerificationEmail(this.user.token).subscribe(res => {
          this.ui.endLoaderWithMessage('Email sent!');
          this.openEmailVerificationDialog();
        }, err => {
          this.openEmailVerificationDialog(true);
          this.ui.emitLoaderState(false);
        });
      }
      // Invalid
      if (!result === undefined || result.length !== 4 && result !== 'LOGOUT' && result !== 'RESEND') {
        this.openEmailVerificationDialog(true);
        this.ui.emitLoaderState(false);
      }
      // Good input - hit the API
      if (result.length === 4) {
        this.verifyEmail(result);
      }
      // Log out user
      if (result === 'LOGOUT') {
        this.logout();
      }
    });
  }

  promiseUserObject(): Promise<any> {
    const userAuth = localStorage.getItem('SSUserCookie');
    const token = JSON.parse(userAuth).token;
    return new Promise((resolve, reject) => {
      if (this.user.token !== '') {
        resolve(this.user);
      } else {
        this.apiService.isValidToken(token).subscribe(res => {
          this.user.email = res.user.email;
          this.user.firstName = res.user.first_name;
          this.user.lastName = res.user.last_name;
          this.user.token = res.user.token;
          this.user.uid = res.user.uid;
          this.user.req_onboarding = res.req_onboarding;
          this.user.payout_methods = res.payout_methods;
          this.user.req_onboarding.push('onboard_payment');
          this.user.isLoggedIn = true;
          this.user.profImage = res.user.thumb_img;
          this.user.team_auths = res['team_auths'];
          localStorage.setItem('SSUserCookie', JSON.stringify(this.user));
          this.authStateChange.next({ isLoggedIn: this.isLoggedIn() });
          mixpanel.people.set({
            "$email": res.user.email,    // only reserved properties need the $
            "Sign up date": new Date(),    // Send dates in ISO timestamp format (e.g. "2020-01-02T21:07:03Z")
            "USER_ID": res.user.uid,    // use human-readable names
          });

          resolve(this.user);
        }, err => {
          reject(err);
        });
      }
    });
  }
  reloadUser(): Promise<any> {
    const userAuth = localStorage.getItem('SSUserCookie');
    const token = JSON.parse(userAuth).token;
    return new Promise((resolve, reject) => {
      this.apiService.isValidToken(token).subscribe(res => {
        console.log(res);
        this.user.email = res.user.email;
        this.user.firstName = res.user.first_name;
        this.user.lastName = res.user.last_name;
        this.user.token = res.user.token;
        this.user.uid = res.user.uid;
        this.user.req_onboarding = res.req_onboarding;
        this.user.payout_methods = res['payout_methods'];
        this.user.req_onboarding.push('onboard_payment');
        this.user.isLoggedIn = true;
        this.user.profImage = res.user.thumb_img;
        this.user.team_auths = res['team_auths'];
        localStorage.setItem('SSUserCookie', JSON.stringify(this.user));
        this.authStateChange.next({ isLoggedIn: this.isLoggedIn() });
        mixpanel.people.set({
          "$email": res.user.email,    // only reserved properties need the $
          "Sign up date": new Date(),    // Send dates in ISO timestamp format (e.g. "2020-01-02T21:07:03Z")
          "USER_ID": res.user.uid,    // use human-readable names
        });
        resolve(this.user);
      }, err => {
        reject(err);
      });
    });
  }

  verifyEmail(result) {
    this.apiService.verifyEmail(this.user.token, result).subscribe(res => {
      this.ui.endLoaderWithMessage('Email confirmed!');
      this.user.req_onboarding.splice(0, 1);
      this.dialog.closeAll();
      this.ui.forcePageName$.next('NEW GROUP');
    }, err => {
      console.log(err);
      this.ui.emitLoaderState(false);
      this.openEmailVerificationDialog(true);
    });
  }

  loginUserIframe(userData) {
    const result = new Promise((resolve, reject) => {
      this.apiService.login(userData).subscribe(res => {
        if (res.response_info.code === '200') {
          this.user = res.user;
          this.user.req_onboarding = res.req_onboarding;
          this.user.payout_methods = res.payout_methods;
          this.user.team_auths = res.team_auths;
          // set cookie
          this.user.profImage = res.user.thumb_img;
          this.user.firstName = res.user.first_name;
          this.user.lastName = res.user.last_name;
          this.user.token = res.user.token;
          localStorage.setItem('SSUserCookie', JSON.stringify(this.user));
          this.authStateChange.next({ isLoggedIn: this.isLoggedIn() });
          this.authState = true;
          resolve(true);
        } else {
          resolve(false);
        }
      }, err => {
        const errBody = JSON.parse(err._body);
        this.alertService.toasterErrorAleart(errBody.error.message);
        resolve(false);
      });
    });
    return result;
  }

  requestGroupInfo(groupId, phoneNumber) {
    return new Promise((resolve, reject) => {
      this.apiService.requestGroupInfo(this.user.token, groupId, phoneNumber).subscribe(res => {
        resolve(true);
      }, err => {
        reject(err);
      });
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/User/user.service.ts